import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/sdk"
    path="business/services/sdk"
    element={<AsyncPage />}
  />,
];
